import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 收益中心
export default [{
  path: "/pointsList",
  name: "pointsList",
  component: function component() {
    return import("../../../views/points-voucher/pointsList.vue");
  },
  meta: {
    title: "金豆明细",
    foot: true
  }
}, {
  path: "/pointsDetail",
  name: "pointsDetail",
  component: function component() {
    return import("../../../views/points-voucher/pointsDetail.vue");
  },
  meta: {
    title: "权益订单详情",
    foot: true
  }
}, {
  path: "/pointsDropDetail",
  name: "pointsDropDetail",
  component: function component() {
    return import("../../../views/points-voucher/pointsDropDetail.vue");
  },
  meta: {
    title: "平落权益明细",
    foot: true
  }
}, {
  path: "/voucherList",
  name: "voucherList",
  component: function component() {
    return import("../../../views/points-voucher/voucherList.vue");
  },
  meta: {
    title: "消费券明细",
    foot: true
  }
}, {
  path: "/pointsVoucher/voucherOrder",
  component: function component() {
    return import("../../../views/points-voucher/voucherOrder.vue");
  },
  name: "voucherOrder",
  meta: {
    title: "消费券使用明细",
    foot: true
  }
}, {
  path: "/pointsVoucher/recordWeb",
  component: function component() {
    return import("../../../views/points-voucher/recordWeb.vue");
  },
  name: "recordWeb",
  meta: {
    title: "权益/消费券",
    foot: true
  }
}, {
  path: "/pointsVoucher/subsidyOrder",
  component: function component() {
    return import("../../../views/points-voucher/subsidyOrder.vue");
  },
  name: "subsidyOrder",
  meta: {
    title: "补贴记录",
    foot: true
  }
}, {
  path: "/pointsVoucher/subsidyOrderDetail",
  component: function component() {
    return import("../../../views/points-voucher/subsidyOrderDetail.vue");
  },
  name: "subsidyOrderDetail",
  meta: {
    title: "订单补贴详情",
    foot: true
  }
}, {
  path: "/pointsVoucher/accelerateOrder",
  component: function component() {
    return import("../../../views/points-voucher/accelerateOrder.vue");
  },
  name: "accelerateOrder",
  meta: {
    title: "链动加速",
    foot: true
  }
}, {
  path: "/pointsVoucher/relatedOrder",
  component: function component() {
    return import("../../../views/points-voucher/relatedOrder.vue");
  },
  name: "relatedOrder",
  meta: {
    title: "关联订单",
    foot: true
  }
}, {
  path: "/pointsPeriodUnlockDetail/:pointNo",
  component: function component() {
    return import("../../../views/points-voucher/pointsPeriodUnlockDetail.vue");
  },
  name: "pointsPeriodUnlockDetail",
  meta: {
    title: "解锁详情",
    foot: true
  }
}, {
  path: "/pointsPeriodUnlockDetailList/:pointNo/:releaseCycle?",
  component: function component() {
    return import("../../../views/points-voucher/pointsPeriodUnlockDetailList.vue");
  },
  name: "pointsPeriodUnlockDetailList",
  meta: {
    title: "解锁明细",
    foot: true
  }
}, {
  path: "/unlockRecord/:pointNo",
  component: function component() {
    return import("../../../views/points-voucher/unlockRecord.vue");
  },
  name: "unlockRecord",
  meta: {
    title: "解锁记录",
    foot: true
  }
}, {
  path: "/pointsDetailOrderList/:pointNo",
  component: function component() {
    return import("../../../views/points-voucher/pointsDetailOrderList.vue");
  },
  name: "pointsDetailOrderList",
  meta: {
    title: "全部订单",
    foot: true
  }
}, {
  path: "/rightsList",
  component: function component() {
    return import("../../../views/points-voucher/rightsList.vue");
  },
  name: "rightsList",
  meta: {
    title: "权益明细",
    foot: true
  }
}];